namespace GeniuzPOS.InitialData {
    export interface PsPosTouchPanelTypeForm {
        TouchPanelType: Serenity.StringEditor;
        TouchPanelDesc: Serenity.StringEditor;
        POSScreenType: Serenity.RadioButtonEditor;
    }

    export class PsPosTouchPanelTypeForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPosTouchPanelType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosTouchPanelTypeForm.init)  {
                PsPosTouchPanelTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.RadioButtonEditor;

                Q.initFormType(PsPosTouchPanelTypeForm, [
                    'TouchPanelType', w0,
                    'TouchPanelDesc', w0,
                    'POSScreenType', w1
                ]);
            }
        }
    }
}
